import _ from 'lodash'

import { defaultOptions } from '../../utils'
import { AvatarPieceBase } from '../Base'
import { AvatarBodyDefault } from './Default'
import { Icon as AvatarBodyIcon } from './Icon'
import { AvatarBodyWheelchair } from './Wheelchair'

export const NAME = 'body'
export const STYLES = {
  default: AvatarBodyDefault
  // wheelchair: AvatarBodyWheelchair
}
export const INLINE_STYLE = {
  width: '150%',
  height: 'auto',
  left: '50%',
  top: 0,
  position: 'absolute',
  pointerEvents: 'none',
  transform: 'translateX(-50%) translateY(-17.5%)'
}
export const AvatarBody = ({ style, color: colorSlug, ...rest }) => {
  const colorOptions = _.get(defaultOptions, `${NAME}.colors`, [])
  const color = _.find(colorOptions, { slug: colorSlug }) || colorOptions[0]
  const colors = color?.colors

  return (
    <AvatarPieceBase
      {...rest}
      name={NAME}
      STYLES={STYLES}
      style={style}
      colors={colors}
      inlineStyle={INLINE_STYLE}
    />
  )
}

export { AvatarBodyIcon }
